"use strict";

function MySetCookie(e, t, n) {
  var i = new Date(),
    n = (i.setTime(i.getTime() + 24 * n * 60 * 60 * 1e3), "expires=" + i.toUTCString());
  document.cookie = e + "=" + t + ";" + n + ";path=/";
}
function MyGetCookie(e) {
  var n = e + "=",
    i = document.cookie.split(";");
  for (var t = 0; t < i.length; t++) {
    var _e = i[t];
    for (; " " == _e.charAt(0);) _e = _e.substring(1);
    if (0 == _e.indexOf(n)) return _e.substring(n.length, _e.length);
  }
  return "";
}
function AlertMessage(titleMessage, textMessage, iconMessage, timer) {
  var validIcons = ['success', 'error', 'warning', 'info', 'question'];
  var icon = validIcons.includes(iconMessage === null || iconMessage === void 0 ? void 0 : iconMessage.toLowerCase()) ? iconMessage.toLowerCase() : 'info'; // default se valore non valido

  var swalOptions = {
    title: titleMessage,
    text: textMessage,
    icon: icon,
    draggable: true,
    customClass: {
      confirmButton: "btn btn-primary mt-2"
    },
    buttonsStyling: !1,
    showCloseButton: !0
  };
  if (timer) {
    swalOptions.timer = timer;
    swalOptions.timeProgressBar = true;
  }
  Swal.fire(swalOptions);
}
function AlertToast(titleMessage, textMessage, iconMessage, timer) {
  var validIcons = ['success', 'error', 'warning', 'info', 'question'];
  var icon = validIcons.includes(iconMessage === null || iconMessage === void 0 ? void 0 : iconMessage.toLowerCase()) ? iconMessage.toLowerCase() : 'info'; // default se valore non valido

  var Toast = Swal.mixin({
    toast: true,
    animation: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
      popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: timer ? parseInt(timer) : 30000,
    timerProgressBar: !!timer,
    didOpen: function didOpen(toast) {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  Toast.fire({
    icon: icon,
    title: titleMessage,
    text: textMessage
  });
}
function ConfirmMessage(titleMessage, textMessage, confirmButtonTxt, iconMessage, showCancelButton) {
  var validIcons = ['success', 'error', 'warning', 'info', 'question'];
  var icon = validIcons.includes(iconMessage === null || iconMessage === void 0 ? void 0 : iconMessage.toLowerCase()) ? iconMessage.toLowerCase() : 'info'; // default se valore non valido

  return Swal.fire({
    title: titleMessage,
    text: textMessage,
    icon: icon,
    showCancelButton: showCancelButton,
    confirmButtonText: confirmButtonTxt,
    cancelButtonText: "Annulla",
    customClass: {
      confirmButton: "btn btn-primary mt-2",
      cancelButton: "btn btn-cancel mt-2"
    },
    buttonsStyling: !1,
    showCloseButton: !0
  }).then(function (result) {
    return result.isConfirmed; // true se confermato, false se annullato
  });
}